import React, { lazy } from 'react';

import { type Route, type Routes } from 'react-resource-router';

import { componentWithSuspense } from '../../utils';
import { AppAccessGate } from '../AppAccessGate';

const QueryBuilderHome = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_dtac-query-builder-home" */ '../../pages/query-builder/home'
		),
);

const QueryBuilderHomeWithAccess = (): JSX.Element => (
	<AppAccessGate appName="Query Builder">
		<QueryBuilderHome />
	</AppAccessGate>
);

const ROUTE_PREFIX = '/query-builder' as const;

const queryBuilderRoutesObject: Record<string, Route> = {
	home: {
		name: 'query-builder-home',
		path: ROUTE_PREFIX,
		exact: true,
		component: componentWithSuspense(QueryBuilderHomeWithAccess),
	},
} as const;

export const queryBuilderRoutes: Routes = Object.values(queryBuilderRoutesObject);
